export default __webpack_public_path__ + "static/media/star.a4f5a4db.svg";